/**
 * Dummy functions for replacement via `package.json` in browser builds.
 *
 * If we don't include these functions typeorm will throw an error on runtime
 * as well as during webpack builds.
 */
/**
 * Loads all exported classes from the given directory.
 */
export function importClassesFromDirectories(logger, directories) {
  var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [".js", ".cjs", ".ts"];
  return [];
}
/**
 * Loads all json files from the given directory.
 */
export function importJsonsFromDirectories(directories) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ".json";
  return [];
}